export default {
  add: 'Add',
  noCalls: 'No available calls',
  activeCall: 'Active Call',
} as const;
